import React, { useState, useContext } from "react";
import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, LogOut } from "lucide-react";
import { SessionContext } from "../context/sessionContext";
import { useUser } from "../context/UserContext";

const SuperadminLayout = () => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const { logout } = useContext(SessionContext);
  const { userData, profilePicUrl, isLoading, roleName, getInitials } = useUser();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundColor: "#000",
          color: "#fff",
        }}
      >
        Loading...
      </div>
    );
  }

  const username = userData?.username || "User";
  const initials = getInitials();

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      navigate("/log-in", { replace: true });
    } catch (error) {
      console.error("Logout error:", error);
      navigate("/log-in", { replace: true });
    } finally {
      setIsLoggingOut(false);
      setShowUserMenu(false);
    }
  };

  return (
    <div className="admin-portal">
      <div className="admin-sidebar">
        <div className="logo">
          <Link to="/">
            <img
              src="/json-media/img/logo.svg"
              alt="GI"
              width={40}
              style={{ padding: 5, marginBottom: 10 }}
            />
          </Link>
        </div>
        <nav className="admin-nav">
          <NavLink
            to="/superadmin"
            end
            title="Dashboard"
            className={({ isActive }) =>
              `admin-nav-btn ${isActive ? "active" : ""}`
            }
          >
            <LayoutDashboard size={20} />
          </NavLink>

          <NavLink
            to="/superadmin/orgs"
            title="Organizations"
            className={({ isActive }) =>
              `admin-nav-btn ${isActive ? "active" : ""}`
            }
          >
            <Users size={20} />
          </NavLink>
        </nav>
        <div className="admin-user-menu">
          <button
            className="admin-user-avatar"
            onClick={() => setShowUserMenu((v) => !v)}
          >
            {profilePicUrl ? (
              <img
                src={profilePicUrl}
                alt="Superadmin"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ) : (
              initials
            )}
          </button>

          {showUserMenu && (
            <div className="user-dropdown">
              <div className="dropdown-user-info">
                <p>{username}</p>
                <p>{roleName}</p>
              </div>
              <button
                className="logout-btn"
                onClick={handleLogout}
                disabled={isLoggingOut}
              >
                <LogOut size={16} />
                <span>{isLoggingOut ? "Logging out..." : "Logout"}</span>
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
};

export default SuperadminLayout;